import { motion } from "framer-motion";

const PHOTOS = [
  { src: "/images/gallery-1.png", alt: "Смяна на масла и филтри - Mercedes", caption: "Масла и филтри" },
  { src: "/images/gallery-2.png", alt: "Акумулатори за всички МПС - продажба, монтаж, кодиране, гаранция", caption: "Акумулатори" },
  { src: "/images/gallery-3.png", alt: "Тест на акумулатор Banner - 100%", caption: "Тест на акумулатори" },
  { src: "/images/gallery-4.png", alt: "Стикер за обслужване на климатична система - АутоДе", caption: "Климатични системи" },
  { src: "/images/gallery-5.png", alt: "BMW X5 в сервиза на АутоДе 1", caption: "Сервизът" },
];

export default function Gallery() {
  return (
    <section id="gallery" className="bg-[#0A0A0A] py-24 lg:py-32" data-testid="gallery-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <p className="mb-4 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.35em] text-[#39FF14]">
            <span className="font-display text-stroke-green text-3xl">02</span> Галерия
          </p>
          <h2 className="font-display text-3xl font-extrabold uppercase tracking-tight sm:text-5xl">
            От работилницата <span className="text-[#39FF14]">на живо</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:gap-6">
          {PHOTOS.map((p, i) => (
            <motion.figure
              key={p.src}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.12 }}
              className={`group relative overflow-hidden border border-white/10 bg-[#121212] ${i === 0 ? "col-span-2 md:col-span-1" : ""}`}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>
              <figcaption className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-black/90 to-transparent px-4 pb-3 pt-10">
                <span className="text-xs font-bold uppercase tracking-widest text-white">{p.caption}</span>
                <span className="font-display text-xs text-[#39FF14]">{String(i + 1).padStart(2, "0")}</span>
              </figcaption>
              <div className="pointer-events-none absolute inset-0 border-2 border-transparent transition-colors duration-500 group-hover:border-[#39FF14]/60" />
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
